module.exports = __webpack_public_path__ + "static/img/click.602e543.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner/click.gif
// module id = wpts
// module chunks = 118